/*
The Homefiniti retail user feature requires the following form JS and related
functionality.
1. Login Form
- Presentations:
- Form: modal
- Confirmation: none
2. Join Form
- Presentations:
- Form: modal
- Confirmation: modal (the onboarding modal)
3. Forgot Password Request
- Presentations:
- Form: modal
- Confirmation: modal
4. Forgot Passowrd Reset
- Presentations:
- Form: on-page. Since the user arrives at this page by clicking a link they
were emailed, this form is hosted at `password/change/`
- Confirmation: modal  The modal includes redirect to the the dashboard page
since closing the modal alone would present to form again.
5. Change Password Form
- Presentations:
- Form: modal
- Confirmation: modal
6. Preferences Form
- Presentations:
- Form: on-page. These forms are housed within the retail user dashbaord
pages.
- Confirmation: modal
*/

import * as bootstrap from "bootstrap";

window.addEventListener("oi.loaded.form.oi-join-form", function(){
    oi.loaded.form["oi-join-form"].addSuccessAction = function(resp){
        login_join_modal.hide()
        // Update oi.loaded.user to authenticated user details
        if (resp.data.data.retail_user) {
            const userdata = resp.data.data
            new oi.user(userdata)
            if(!onboarding_cookie()){
                onboarding_modal.show()
            }
        }
        // The IFP configure.js needs this value immediately after login.
        window.retail_user = true
    }
})
window.addEventListener("oi.loaded.form.oi-login-form", function(){
    oi.loaded.form["oi-login-form"].addSuccessAction = function(resp){
        login_join_modal.hide()
        // Update oi.loaded.user to authenticated user details
        if (resp.data.data.retail_user) {
            const userdata = resp.data.data
            new oi.user(userdata)
            if(!onboarding_cookie()){
                onboarding_modal.show()
            } else {
                welcome_modal.show()
            }
        }
        // The IFP configure.js needs this value immediately after login.
        window.retail_user = true
    }
})
window.addEventListener("oi.loaded.form.oi-password-forgot-form", function(){
    oi.loaded.form["oi-password-forgot-form"].addSuccessAction = function(){
        password_forgot_modal.hide()
        confirmation_title.innerHTML = `Check your email!`
        confirmation_message.innerHTML = `Please check your email now for instructions to reset your password.`
        confirmation_modal.show()
        setTimeout(function(){
            confirmation_modal.hide()
            confirmation_title.innerHTML = ``
            confirmation_message.innerHTML = ``
        }, 4000)
    }
})
window.addEventListener("oi.loaded.form.oi-password-change-form", function(){
    oi.loaded.form["oi-password-change-form"].addSuccessAction = function(){
        password_change_modal.hide()
        confirmation_title.innerHTML = `Password Updated`
        confirmation_message.innerHTML = `You are still logged in. Enjoy!`
        confirmation_modal.show()
        setTimeout(function(){
            confirmation_modal.hide()
            confirmation_title.innerHTML = ``
            confirmation_message.innerHTML = ``
        }, 5000)
    }
})
window.addEventListener("oi.loaded.form.oi-password-forgot-change-form", function(){
    oi.loaded.form["oi-password-forgot-change-form"].addSuccessAction = function(){
        confirmation_title.innerHTML = `<i class="fa fa-check"></i> Password Updated`
        confirmation_message.innerHTML = `Your password has been changed and we're logging you in now!<br/><p class="mt-3 text-center"><i class="fa fa-3x fa-spinner fa-spin"></i></p>`
        confirmation_modal.show()
        setTimeout(function(){
            const slug = window.oi_preload.dashboard_slug || "my-portal"
            window.location = `/${slug}/`
        }, 6500)
    }
})
window.addEventListener("oi.loaded.form.oi-profile-form", function(){
    oi.loaded.form["oi-profile-form"].addSuccessAction = function(resp){
        confirmation_title.innerHTML = ``
        confirmation_message.innerHTML = resp.data.message
        confirmation_modal.show()
        setTimeout(function(){
            confirmation_modal.hide()
            confirmation_title.innerHTML = ``
            confirmation_message.innerHTML = ``
        }, 4000);
    }
})
window.addEventListener("oi.loaded.form.oi-pref-form", function(){
    oi.loaded.form["oi-pref-form"].addSuccessAction = function(resp){
        confirmation_title.innerHTML = ``
        confirmation_message.innerHTML = resp.data.message
        confirmation_modal.show()
        setTimeout(function(){
            confirmation_modal.hide()
            confirmation_title.innerHTML = ``
            confirmation_message.innerHTML = ``
        }, 4000);
    }
    oi.loaded.form["oi-pref-form"].addErrorAction = function(resp){
        confirmation_title.innerHTML = ``
        confirmation_message.innerHTML = resp.data.message
        confirmation_modal.show()
        setTimeout(function(){
            confirmation_modal.hide()
            confirmation_title.innerHTML = ``
            confirmation_message.innerHTML = ``
        }, 4000);
    }
})
const body = document.body,
retail_user = function(){ return oi.loaded.user && oi.loaded.user.authenticated },
// Login & Join form elements"
login_link = document.querySelectorAll(".oi-login-link"),
join_link = document.querySelectorAll(".oi-join-link"),
// Login/Join tab elements
login_join_panes = document.querySelectorAll(".oi-login-join-pane"),
login_tab_element = document.getElementById("oi-login-nav-tab"),
login_tab = bootstrap.Tab.getOrCreateInstance(login_tab_element),
join_tab_element = document.getElementById("oi-join-nav-tab"),
join_tab = bootstrap.Tab.getOrCreateInstance(join_tab_element),
login_pane = document.getElementById("oi-login-pane"),
join_pane = document.getElementById("oi-join-pane"),
// Optional Login/Join switcher
login_join_switcher = document.querySelectorAll("input[name='oi-login-join-switcher']"),
login_switch_radio = document.getElementById("oi-login-switch"),
join_switch_radio = document.getElementById("oi-join-switch"),
login_join_modal_element = document.getElementById("oi-login-join-modal"),
login_join_modal = bootstrap.Modal.getOrCreateInstance(login_join_modal_element),
login_modal_force = (/login/.test(window.location.hash)),
join_modal_force = (/join/.test(window.location.hash)),
// Forgot Password elements
password_forgot_link = document.querySelectorAll(".oi-forgot-password-link"),
password_forgot_modal_element = document.getElementById("oi-password-forgot-modal"),
password_forgot_modal = bootstrap.Modal.getOrCreateInstance(password_forgot_modal_element),
// Password change for elements.
// Used on Dashboard page for logged in users.
password_change_link = document.querySelectorAll(".oi-password-change-link"),
password_change_modal_element = document.getElementById("oi-password-change-modal"),
password_change_modal = bootstrap.Modal.getOrCreateInstance(password_change_modal_element),
// Confirmation modal elements.
// Used by multiple forms and filled with necessary content for each.
confirmation_modal_element = document.getElementById("oi-confirmation-modal"),
confirmation_modal = bootstrap.Modal.getOrCreateInstance(confirmation_modal_element),
confirmation_title = confirmation_modal_element.querySelector(".modal-title"),
confirmation_message = confirmation_modal_element.querySelector("p.message"),
// Onboarding elements
onboarding_modal_element = document.getElementById("oi-onboarding-modal"),
onboarding_modal = bootstrap.Modal.getOrCreateInstance(onboarding_modal_element),
onboarding_cookie = function(){ return oi.utils.cookie.get("onboarding","onboarding")},
onboarding_force = (/onboarding/.test(window.location.hash)),
// Welcome elements
welcome_modal_element = document.getElementById("oi-welcome-modal"),
welcome_modal = bootstrap.Modal.getOrCreateInstance(welcome_modal_element),
welcome_modal_force = (/welcome/.test(window.location.hash)),
// Interactive Floorplan elements
delete_ifp_link = document.querySelectorAll(".delete-ifp");
window.addEventListener("load", () => {
    window.join_pane_show = function(){
        if(login_join_switcher.length){
            join_switch_radio.checked = true
        }
        join_tab.show()
    }
    window.login_pane_show = function(){
        if(login_join_switcher.length){
            login_switch_radio.checked = true
        }
        login_tab.show()
    }
    login_join_switcher.forEach(radio => {
        radio.addEventListener('change', function() {
            (this.value == "join") ? join_pane_show() : login_pane_show()
        })
    })
    // Set the Onboarding cookie after displayed
    onboarding_modal_element.addEventListener('shown.bs.modal', function (e) {
        if(!onboarding_cookie()){
            oi.utils.cookie.set("onboarding", "onboarding")
        }
    });
    // Catch repeat attempts to show onboarding unless explicitly fired
    onboarding_modal_element.addEventListener('show.bs.modal', function (e) {
        if(onboarding_cookie() && (!onboarding_force)){
            return false
        }
    });
    // Remove hash from URL on close to prevent reopening on back button clicks.
    onboarding_modal_element.addEventListener('hidden.bs.modal', function (e) {
        oi.utils.removeHash()
    });
    // Remove hash from URL on close to prevent reopening on back button clicks.
    welcome_modal_element.addEventListener('hidden.bs.modal', function (e) {
        oi.utils.removeHash()
    });
    // Force the onboarding modal display with '#onboarding' in the URL
    if(onboarding_force && retail_user()){
        onboarding_modal.show()
    }
    // Force the welcome modal display with '#welcome' in the URL
    if(welcome_modal_force && retail_user()){
        welcome_modal.show()
    }
    // Display the onboarding modal if a user is logged in, but does not have the
    // onboarding cookie set.
    if(retail_user() && !onboarding_cookie()){
        onboarding_modal.show()
    }
    /*
    * For the oi-favorite-action and oi-login-required classes, we listen for clicks that
    * bubble up to the document level. This ensures that elements added to the DOM after
    * page load (as search result cards often are) will have the desired behaviors.
    *
    * We check for the class of the clicked element, but also if the clicked element is
    * contained in an element that matches out classes.
    */
    document.addEventListener("click", function(e){
        if (oi.loaded.user && oi.loaded.user.authenticated) {
            return
        }
        const login_required_click = e.target.closest(".oi-login-required")
        if (login_required_click) {
            e.preventDefault()
            login_join_modal.show()
            login_pane_show()
            // If the triggering click occured on a favorite button, store the
            // homefiniti_id so it can be favorited immediately after the login/join
            // process completes.
            if (login_required_click.dataset.oiUserAction == "favorite") {
                const homefiniti_id = login_required_click.dataset.homefinitiId
                if (homefiniti_id) {
                    oi.state.oiuser_staged = homefiniti_id
                }
            }
        }
    })
    login_link.forEach(link => {
        link.addEventListener("click", function(e){
            e.preventDefault();
            login_join_modal.show();
            login_pane_show();
        })
    })
    join_link.forEach(link => {
        link.addEventListener("click", function(e){
            e.preventDefault();
            login_join_modal.show()
            join_pane_show();
        })
    })
    password_forgot_link.forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            password_forgot_modal.show()
            login_join_modal.hide()
        })
    })
    password_change_link.forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            password_change_modal.show()
        })
    })
    /*
    * Trigger the login/join modal on page load by adding a "#login" hash to any URL. This
    * allows the client to drive consumers to login, but eliminates the need for a unique URL.
    */
    if(login_modal_force){
        login_join_modal.show()
    }
    /*
    * Trigger the login/join modal (with the join tab active) on page load by adding a
    * "#join" hash to any URL. This allows the client to drive consumers to join, but
    * eliminates the need for a unique URL.
    */
    if(join_modal_force){
        login_join_modal.show()
        join_pane_show();
    }
    /**
    * The IFP configurator.js file checks for the existence of the ifp_login_override()
    * function before displaying the IFP-version of the login/join modal. Overriding
    * this default behavior means we can show the same login/join modal seen elsewhere
    * in the theme for a more consistent user experience.
    */
    window.ifp_login_override = function() {
        login_join_modal.show()
    }
    // Delete a saved IFP configuration from the Retail User Dashboard.
    delete_ifp_link.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault()
            const ifpcard = link.closest(".oi-saved-ifp-card")
            const uuid = link.dataset.uuid
            const endpoint = `/ifp/saved/${uuid}/`
            oi.axios({
                method: 'delete',
                url: endpoint,
            })
            .then(function (resp){
                ifpcard.style.display = "none"
                confirmation_title.innerHTML = `Configuration Removed`
                confirmation_message.innerHTML = resp.data.message
            })
            .catch(function (resp){
                confirmation_title.innerHTML = `Oops...`
                confirmation_message.innerHTML = resp.data.message
            })
            .then(function (){
                confirmation_modal.show()
                setTimeout(function(){
                    confirmation_modal.hide()
                    confirmation_title.innerHTML= ``
                    confirmation_message.innerHTML= ``
                }, 15000)
            })
        })
    })
    /**
    * These variables and listeners work with the Bootstrap Tab JS to provide all views
    * of the Retail User dashboard with permalink functionality.
    * (1) Pushes the active tab ID to the URL as a #hash.
    * (2) Listens for a hash value on page load and confirms a matching view exists.
    * (3) If #2 is confirmed, load the appropriate tab view.
    * (4) If no hash exists, or the hash does not match a tab, make the default tab visible.
    *
    */
    // Checks the <body> class to identify if this is a dashboard view.
    const is_retail_user_dashboard = document.body.classList.contains("retail-user-dashboard")
    if(is_retail_user_dashboard) {

        // The Account Overview tab is loaded when there is no valid request for an alternative.
        let hash_load = "#overview"

        let link_content;
        const dropdownlinks = document.querySelectorAll('#dashboard-tabs .dropdown-item');
        const dropdownmenu_main = document.getElementById('dashboard-dropdown-toggle');
        const dropdownmenu_menu = document.getElementById('dashboard-dropdown');

        // If there is a hash in the URL, validate a matching tab panel exists.
        if (window.location.hash) {
            const panel_id = window.location.hash.slice(1)
            const panel = document.getElementById(panel_id)
            if (panel && (panel.getAttribute("role") == "tabpanel")) {
                // Override hash_load when validated.
                hash_load = window.location.hash
            }
        }

        // Update active text to match the selected tab
        dropdownlinks.forEach(link => {
            if (window.location.hash == link.dataset.bsTarget) {
                link_content = link.innerHTML;
                dropdownmenu_main.innerHTML = link_content
            }
            link.addEventListener('click', function () {
                link_content = link.innerHTML;
                let linkHash = link.dataset.bsTarget;
                window.location.hash= linkHash;
                window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })
                if(link_content) {
                    dropdownmenu_main.innerHTML = link_content
                }
            });
        });

        // Collect all desktop & mobile tablinks to make selections and state adjustments.
        const tablinks_init = document.querySelectorAll('a.nav-link[data-bs-target="'+hash_load+'"]')
        const tablink_target = bootstrap.Tab.getOrCreateInstance(tablinks_init[0])
        const tablinks_all = document.querySelectorAll('a.nav-link[data-bs-toggle="pill"]')

        // Show the correct tab panel if it exists.
        if(tablinks_init.length) {
            tablink_target.show()
        }
        // Adjust the tablink active state and add the eventListener to update the hash as
        // the user navigates the submenu.
        tablinks_all.forEach((tablink) => {
            if (tablink.dataset.bsTarget != hash_load) {
                tablink.classList.remove("active")
                tablink.setAttribute("aria-selected", false)
            }
            else {
                tablink.classList.add("active")
                tablink.setAttribute("aria-selected", true)
            }
            // Adds the selected tab id as a URL hash to allow for Dashboard permalinking
            tablink.addEventListener('shown.bs.tab', function (event) {
                const hash = event.target.dataset.bsTarget.slice(1)
                // adding this to scroll to the very top when main nav is fixed
                window.location.hash = hash
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
            })
        })
    }
})
